// extracted by mini-css-extract-plugin
module.exports = {"description-content":"description-content-IWeWXO6"};